/**
 * Checks if object is present in an array
 * @param {Array<string>} ob
 * @return {boolean}
 */
String.prototype.oneIn = (ob: Array<string>): boolean => {
  const s = this;
  return ob.indexOf(s) > -1;
};
